// src/js/modules/email-obfuscation.js
const initEmailObfuscation = () => {
  const nodes = document.querySelectorAll("[data-email]");
  if (!nodes || nodes.length === 0) return;

  nodes.forEach((el) => {
    // leer y decodificar datos
    const local = el.dataset.local ? atob(el.dataset.local) : "";
    const domain = el.dataset.domain ? atob(el.dataset.domain) : "";
    if (!local || !domain) return;

    const email = `${local}@${domain}`;

    // decodeURIComponent porque el shortcode guardó encodeURIComponent()
    const subject = el.dataset.subject
      ? decodeURIComponent(el.dataset.subject)
      : "";
    const body = el.dataset.body ? decodeURIComponent(el.dataset.body) : "";
    const style = el.dataset.style || "icon";
    const feedbackMsg = el.dataset.copyFeedback || "¡Correo copiado!";
    const feedbackEl = el.querySelector(".feedback-message");

    // construir mailto con encoding correcto
    const params = new URLSearchParams();
    if (subject) params.set("subject", subject);
    if (body) params.set("body", body);
    const mailto = params.toString()
      ? `mailto:${email}?${params.toString()}`
      : `mailto:${email}`;

    // mejora progresiva: si es <a> podemos colocar href para que funcione sin JS
    if (el.tagName.toLowerCase() === "a") {
      el.setAttribute("href", mailto);
    }

    const showFeedback = (msg) => {
      if (!feedbackEl) return;
      feedbackEl.textContent = msg;
      feedbackEl.classList.add("is-visible");
      // se anuncia por aria-live="polite"
      setTimeout(() => feedbackEl.classList.remove("is-visible"), 1800);
    };

    const doNavigateMailto = () => {
      // abrir mailto sin cancelar la promesa previa: usar small delay
      // Si está en un <a> con target=_blank, podríamos usar window.open(mailto), pero
      // aquí abrimos por asignación para máxima compatibilidad (esto abrirá cliente).
      window.location.href = mailto;
    };

    const handleActivate = async (ev) => {
      ev.preventDefault();

      // marcar busy para accesibilidad (opcional)
      el.setAttribute("aria-busy", "true");

      // 1) Intentar copiar al portapapeles (si está disponible)
      let copied = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(email);
          copied = true;
          showFeedback(feedbackMsg);
        } catch (err) {
          // fallo por permiso o cancelación (ej. navegación temprana)
          copied = false;
          showFeedback("Copia no disponible");
          // no return here — abrimos mailto aun en error
        }
      } else {
        // Clipboard API no disponible (http no seguro, navegador antiguo...)
        showFeedback("Copia no disponible");
      }

      // 2) Pequeño delay para evitar que la navegación mate la operación anterior
      //    (si quieres navegación inmediata sin esperar a la copia, elimina el await y delay)
      setTimeout(() => {
        doNavigateMailto();
        // quitar aria-busy tras navegación tentativa; esto puede que no se ejecute si
        // el navegador realmente abandona la página, pero es inocuo.
        setTimeout(() => el.removeAttribute("aria-busy"), 1000);
      }, 250);
    };

    // listeners
    el.addEventListener("click", handleActivate);

    // keyboard support (Enter / Space)
    el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleActivate(e);
      }
    });
  });
};

export default initEmailObfuscation;
